import React, { useState, useEffect } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import avatar from "../../Assets/avatar.jpg";
import "./PCScientificCommittee.css";

const PCScientificCommittee = () => {
  const [committeeMembers, setCommitteeMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCommitteeMembers = async () => {
      try {
        const response = await fetch(
          "https://api.dremerz.net/api/DZ_8922_Ampicon_Program_PreConference_OrganizingCommitteeMembersList"
        );
        if (!response.ok) {
          throw new Error("Failed to fetch committee members");
        }
        const data = await response.json();
        setCommitteeMembers(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCommitteeMembers();
  }, []);

  if (loading) {
    return (
      <section className="py-5 text-center" style={{ backgroundColor: "#FFF4FA" }}>
        <Container>
          <h3 className="mb-5 fw-bold">Organizing Committee</h3>
          <p>Loading committee members...</p>
        </Container>
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-5 text-center" style={{ backgroundColor: "#FFF4FA" }}>
        <Container>
          <h3 className="mb-5 fw-bold">Organizing Committee</h3>
          <p className="text-danger">Error: {error}</p>
        </Container>
      </section>
    );
  }

  return (
    <section className="py-5 text-center" style={{ backgroundColor: "#FFF4FA" }}>
      <Container>
        <h3 className="mb-5 fw-bold">Organizing Committee</h3>
        <Row className="justify-content-center">
          {committeeMembers.map((member) => (
            <Col
              key={member.id}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              className="d-flex flex-column align-items-center mb-4"
            >
              <Image
                src={member.img ? `https://api.dremerz.net/uploads/${member.img}` : avatar}
                roundedCircle
                alt={member.name}
                width={150}
                height={150}
                style={{ objectFit: "cover" }}
              />
              <p className="mt-3 mb-1 fw-semibold">{member.role}</p>
              <p className="text-danger fw-bold mb-1">{member.name}</p>
              <p className="mb-0 text-muted text-center">
                {member.affiliation}
              </p>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default PCScientificCommittee;